import React from 'react';
import Frame from '../../Frame';
interface TableFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  setHeight?: (height: number) => void;
}

const TableFrame = ({ setHeight, children }: TableFrameProps) => {
  const frameRef = React.useRef<HTMLLabelElement>(null);
  React.useEffect(() => {
    if (frameRef.current) {
      setHeight && setHeight(frameRef.current.clientHeight);
    }
  }, []);

  return <Frame ref={frameRef}>{children}</Frame>;
};

export default TableFrame;
